import { guidePropertiesSelector } from '../selectors/properties';
import { guideChangeSelectedIndexThunkAction } from './changeSelectedIndex';
import { guidePlaySelectedChannelThunkAction } from './playSelectedChannel';

export const guidePlayPreviousPlayedChannelThunkAction = () => async (dispatch, getState) => {
  const state = getState();

  const { previousPlayingIndex } = guidePropertiesSelector(state);
  await dispatch(guideChangeSelectedIndexThunkAction({ newIndex: previousPlayingIndex }));

  return dispatch(guidePlaySelectedChannelThunkAction());
};
